// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.manage-listing-block-container {
  display: flex;
  align-items: center;
}
.manage-listing-block-container .item-image {
  margin-left: 24px;
  height: 40px;
  width: 40px;
  object-fit: cover;
  border-radius: 8px;
}
.manage-listing-block-container .details {
  width: 150px;
  font-family: "Proxima Nova", sans-serif;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
}
.manage-listing-block-container .details > p {
  margin: 0;
  font-size: 14px;
}
.manage-listing-block-container .details > p.name {
  width: 150px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.manage-listing-block-container .details > p.name, .manage-listing-block-container .details > p.id {
  font-weight: 700;
  color: var(--secondary-color-1);
}
.manage-listing-block-container .details > p.address {
  font-weight: 600;
  font-size: 10px;
  color: var(--secondary-color-3);
  width: 150px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

@media (min-width: 768px) and (max-width: 1024px), (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
  .manage-listing-block-container .details {
    width: 100px;
  }
  .manage-listing-block-container .details > p.name {
    width: 100px;
  }
  .manage-listing-block-container .details > p.address {
    width: 100px;
  }
}
@media (min-width: 481px) and (max-width: 767px), (min-width: 320px) and (max-width: 480px) {
  .manage-listing-block-container .item-image {
    margin-left: 0;
    height: 60px;
    width: 60px;
  }
  .manage-listing-block-container .details {
    width: 100%;
    text-align: left;
  }
  .manage-listing-block-container .details > p.name {
    width: 100%;
  }
  .manage-listing-block-container .details > p.address {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/routes/AgentDashboard/modules/ManageListings/modules/ListingBlock/listingBlock.scss","webpack://./src/assets/styles/_mixins.scss"],"names":[],"mappings":"AAEA;EACI,aAAA;EACA,mBAAA;AADJ;AAEI;EACI,iBAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;AAAR;AAEI;EACI,YAAA;EACA,uCAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,kBAAA;AAAR;AACQ;EACI,SAAA;EACA,eAAA;AACZ;AAAY;EACI,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAEhB;AAAY;EACI,gBAAA;EACA,+BAAA;AAEhB;AAAY;EACI,gBAAA;EACA,eAAA;EACA,+BAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAEhB;;AC/BY;EDqCJ;IACI,YAAA;EAFV;EAIc;IACI,YAAA;EAFlB;EAIc;IACI,YAAA;EAFlB;AACF;AClDY;ED6DJ;IACI,cAAA;IACA,YAAA;IACA,WAAA;EARV;EAUM;IACI,WAAA;IACA,gBAAA;EARV;EAUc;IACI,WAAA;EARlB;EAUc;IACI,WAAA;EARlB;AACF","sourcesContent":[" @import 'assets/styles/_mixins.scss';\r\n\r\n.manage-listing-block-container {\r\n    display: flex;\r\n    align-items: center;\r\n    .item-image {\r\n        margin-left: 24px;\r\n        height: 40px;\r\n        width: 40px;\r\n        object-fit: cover;\r\n        border-radius:  8px;\r\n    }\r\n    .details {\r\n        width: 150px;\r\n        font-family: 'Proxima Nova', sans-serif;                                             \r\n        display: flex;\r\n        flex-direction: column;\r\n        justify-content: center;\r\n        position: relative;\r\n        > p {\r\n            margin: 0;\r\n            font-size: 14px;\r\n            &.name {\r\n                width: 150px;\r\n                white-space: nowrap;\r\n                overflow: hidden;\r\n                text-overflow: ellipsis;\r\n            }\r\n            &.name, &.id {\r\n                font-weight: 700;\r\n                color: var(--secondary-color-1);\r\n            }\r\n            &.address {\r\n                font-weight: 600;\r\n                font-size: 10px;\r\n                color: var(--secondary-color-3);\r\n                width: 150px;\r\n                white-space: nowrap;\r\n                overflow: hidden;\r\n                text-overflow: ellipsis;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n@include media(tablet) {\r\n    .manage-listing-block-container {\r\n        .details {\r\n            width: 100px;\r\n            > p {\r\n                &.name {\r\n                    width: 100px;\r\n                }\r\n                &.address {\r\n                    width: 100px;\r\n\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n@include media(mobile) {\r\n    .manage-listing-block-container {\r\n        .item-image {\r\n            margin-left: 0;\r\n            height: 60px;\r\n            width: 60px;\r\n        }\r\n        .details {\r\n            width: 100%;\r\n            text-align: left;\r\n            > p {\r\n                &.name {\r\n                    width: 100%;\r\n                }\r\n                &.address {\r\n                    width: 100%;\r\n\r\n                }\r\n            }\r\n        }\r\n    }\r\n}","@mixin media($keys...) {\r\n    @each $key in $keys {\r\n        @if ($key==mobile) {\r\n            @media (min-width: 481px) and (max-width: 767px),\r\n            (min-width: 320px) and (max-width: 480px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==tablet) {\r\n            @media (min-width: 768px) and (max-width: 1024px),\r\n            (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==nitty-gritt) {\r\n            @media (width: 1024px) and (max-height: 833px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==small-desktop) {\r\n            @media (max-width: 1440px) and (max-height: 833px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==desktop) {\r\n            @media (min-width: 1024px) and (max-width: 1440px) {\r\n                @content;\r\n            }\r\n        }\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
